export const columnsDataCurrency = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Data registrada",
    accessor: "registrationDate",
  },
  {
    Header: "De Moeda",
    accessor: "fromCurrency",
  },
  {
    Header: "Para Moeda",
    accessor: "toCurrency",
  },
  {
    Header: "Valor",
    accessor: "exchangeRate",
  },
];

export const financialExpenseColumns = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "No Doc.",
    accessor: "seqNumber",
  },
  {
    Header: "Beneficiario",
    accessor: "beneficiary",
  },
  {
    Header: "Descrição",
    accessor: "description",
  },
  {
    Header: "Crédito",
    accessor: "amount",
  },
  {
    Header: "Pgto Banco",
    accessor: "registrationDate",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
  {
    id: "report",
    Header: "Relatórios",
    accessor: "report",
  },
  {
    id: "delete",
    Header: "Eliminar",
    accessor: "delete",
  }
];

export const financialIncomeColumns = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "SIGFE",
    accessor: "sigfe",
  },
  {
    Header: "No Doc.",
    accessor: "seqNumber",
  },
  {
    Header: "Beneficiario",
    accessor: "beneficiary",
  },
  {
    Header: "Descrição",
    accessor: "description",
  },
  {
    Header: "Débito",
    accessor: "amount",
  },
  {
    Header: "Data recebimento",
    accessor: "receivedDate",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
  {
    id: "report",
    Header: "Relatórios",
    accessor: "report",
  },
  {
    id: "delete",
    Header: "Eliminar",
    accessor: "delete",
  }
];

export const financialTransferColumns = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Departamento de origem",
    accessor: "sourceDepartment",
  },
  {
    Header: "Conta de origem",
    accessor: "sourceAccount",
  },
  {
    Header: "Departamento de destino",
    accessor: "destinationDepartment",
  },
  {
    Header: "Conta de destino",
    accessor: "destinationAccount",
  },
  {
    Header: "Descrição",
    accessor: "description",
  },
  {
    Header: "Data registro",
    accessor: "registrationDate",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
  {
    id: "report",
    Header: "Relatórios",
    accessor: "report",
  },
  {
    id: "delete",
    Header: "Eliminar",
    accessor: "delete",
  }
];
